<template>
  <v-container style="height: 100%;">

    <v-card>
      <v-card-text>
        <v-text-field v-model="token" label="Token"></v-text-field>
      </v-card-text>

      <v-card-actions class="d-flex justify-center">
        <v-btn @click="login()" color="success">
          Login
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Login',

  data: () => ({
    token: ''
  }),

  methods: {
    login() {
      let _ = this

      if (!_.token || _.token.length === 0) {
        _.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'Please check the token!'
        })

        return
      }

      localStorage.setItem('jwt', _.token)
      _.$router.push('/list')
    }
  }
}
</script>
